export const CDN_URL = process.env.REACT_APP_CDN_URL || '';
export const FRONT_COVER_ID = 'front-cover';
export const BACK_COVER_ID = 'back-cover';
export const SCHOLARS_ID = 'scholars';
export const MI_BY_THE_NUMBERS_ID = 'mi-by-the-numbers';
export const BOARD_OF_TRUSTEES_ID = 'board-of-trustees';
export const LETTER_FROM_THE_PRESIDENT_ID = 'letter-from-the-president';
export const DEFAULT_SLIDE_KEY = 'slide';
